import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BRAND_NAME } from '../api/config';
import { IconMenu, IconX } from './Icons';

const NAV = [
  { to: '/', label: 'Search' },
  { to: '/downloads', label: 'My Reports' },
  { to: '/contact', label: 'Contact' },
];

export function SiteHeader() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-parchment/95 backdrop-blur border-b-2 border-sand">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
        <Link to="/" className="group flex items-baseline gap-2" onClick={() => setOpen(false)}>
          <span className="font-serif text-2xl text-forest font-semibold tracking-tight group-hover:text-moss transition-colors">
            {BRAND_NAME}
          </span>
          <span className="hidden sm:inline text-[10px] uppercase tracking-[0.2em] text-clay font-semibold">
            Registry
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((item) => {
            const active = location.pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`text-sm font-semibold transition-colors relative py-1 ${
                  active ? 'text-forest' : 'text-ink/60 hover:text-forest'
                }`}
              >
                {item.label}
                {active && (
                  <span className="absolute -bottom-[17px] left-0 right-0 h-0.5 bg-clay" />
                )}
              </Link>
            );
          })}
        </nav>

        <button
          type="button"
          className="md:hidden p-2 text-forest"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <IconX /> : <IconMenu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-sand bg-white px-4 py-4 space-y-1">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              className="block py-3 px-2 text-sm font-semibold text-forest border-b border-sand last:border-0"
            >
              {item.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className="border-t-2 border-sand bg-white mt-auto">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div>
          <p className="font-serif text-xl text-forest font-semibold">{BRAND_NAME}</p>
          <p className="text-sm text-ink/60 mt-1 max-w-sm">
            Maharashtra property registry search — locate Index-II and sale deed records online.
          </p>
        </div>
        <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm font-semibold text-ink/70">
          <Link to="/privacy" className="hover:text-clay transition-colors">Privacy</Link>
          <Link to="/terms" className="hover:text-clay transition-colors">Terms</Link>
          <Link to="/contact" className="hover:text-clay transition-colors">Contact</Link>
        </div>
      </div>
      <div className="border-t border-sand py-4 text-center text-xs text-ink/50">
        © {new Date().getFullYear()} {BRAND_NAME}. Informational use only.
      </div>
    </footer>
  );
}

export function PageShell({ children, className = '' }) {
  return (
    <div className={`min-h-screen flex flex-col ${className}`}>
      <SiteHeader />
      <main className="flex-1">{children}</main>
      <SiteFooter />
    </div>
  );
}
